export const DEFAULT_INITIAL_NUMBER_OF_TICKETS = 15;
export const INCREMENT_TICKET_COUNT_BY = 15;
export const SAC_URL =
    process.env["NODE_ENV"] === "production"
        ? "https://support.atlassian.com"
        : "https://support.stg.internal.atlassian.com";
